export const NavController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.initMobileMenu();
        this.resizeMenu();

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  resizeMenu() {
    window.addEventListener('scroll', function () {
      const header = document.querySelector('.header');
      const scroll = window.scrollY;

      if (scroll >= 300) {
        header.classList.add('resized');
      } else {
        header.classList.remove('resized');
      }
    });
  },

  initMobileMenu() {
    const nav = document.querySelector('.nav');
    const menu = document.querySelector('.nav__menu');
    const hamburguer = document.querySelector('.hamburguer-icon');
    const parentEl = document.querySelector('.menu-item-has-children a');
    const body = document.body;

    if (hamburguer && nav && menu) {
      hamburguer.addEventListener('click', function () {
        this.classList.toggle('open');
        nav.classList.toggle('active');
        menu.classList.toggle('active');
        body.style.overflow = body.style.overflow === 'hidden' ? '' : 'hidden';
      });
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        nav.classList.remove('active');
        menu.classList.remove('active');
        hamburguer.classList.remove('open');
        body.style.overflow = '';

        // Remove active from parent element
        if (parentEl) {
          parentEl.classList.remove('active');
        }

        // Close all opened submenus
        document.querySelectorAll('.sub-menu.open').forEach((sub) => {
          sub.classList.remove('open');
          sub.parentElement.classList.remove('submenu-open');
        });
      }
    });

    // Mobile submenu toggle
    document.querySelectorAll('.nav__menu > li.menu-item-has-children').forEach((li) => {
      const link = li.querySelector('a');
      const submenu = li.querySelector('.sub-menu');
      const parentEl = li.querySelector('.menu-item-has-children a');

      if (submenu) {
        link.addEventListener('click', function (e) {
          if (window.innerWidth <= 768) {
            e.preventDefault();
            submenu.classList.toggle('open');
            parentEl.classList.toggle('active');
            li.classList.toggle('submenu-open');
          }
        });
      }
    });
  },
};
